export const isPdfFile = (fileType: string) => {
  return fileType === 'application/pdf';
};

export const isImageFile = (fileType: string) => {
  return fileType.startsWith('image/');
};

export const isWordFile = (fileType: string) => {
  return fileType === 'application/msword' || 
         fileType === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
};

export const isExcelFile = (fileType: string) => {
  return fileType === 'application/vnd.ms-excel' || 
         fileType === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
};
